import React, { useState } from 'react';
import { Card, CardContent, Typography, Box, CircularProgress } from '@mui/material';
import { Button } from '@/components/ui/button';

interface WorkflowCreationFormProps {
  onCreateWorkflow: (businessName: string) => Promise<void>;
  isCreating: boolean;
}

const WorkflowCreationForm: React.FC<WorkflowCreationFormProps> = ({
  onCreateWorkflow,
  isCreating
}) => {
  const [businessName, setBusinessName] = useState<string>('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (businessName.trim()) {
      await onCreateWorkflow(businessName);
    }
  };

  return (
    <div className="container mx-auto py-8 space-y-8">
      <h1 className="text-3xl font-bold">Create a New Workflow</h1>
      
      <Card>
        <CardContent>
          <Typography variant="h6" fontWeight="bold" mb={2}>Before you begin</Typography>
          <Typography variant="body2" color="text.secondary" mb={2}>
            To analyze keywords, you need to create a workflow first. This helps organize your analysis and track results.
          </Typography>
          
          <form onSubmit={handleSubmit}>
            <Box mb={2}>
              <Typography variant="body2" fontWeight="medium" mb={1}>Business Name</Typography>
              <input 
                type="text"
                className="w-full p-2 border rounded"
                value={businessName}
                onChange={(e) => setBusinessName(e.target.value)}
                placeholder="Enter business name"
                required
              />
            </Box>
          
            <Button 
              type="submit"
              disabled={isCreating || !businessName.trim()}
              className="w-full"
            >
              {isCreating ? (
                <>
                  <CircularProgress size={16} className="mr-2" />
                  Creating...
                </>
              ) : (
                'Create Workflow'
              )}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default WorkflowCreationForm;
